import type { WebTrpcClient } from '../trpc/client.js';
import type { AnalyticsCapturePort } from './AnalyticsCapturePort.js';

/** Cookie-authenticated browser adapter for the passive member analytics procedures. */
export class TrpcAnalyticsCaptureAdapter implements AnalyticsCapturePort {
  readonly #client: WebTrpcClient;

  constructor(client: WebTrpcClient) {
    this.#client = client;
  }

  async pageView(
    input: Parameters<AnalyticsCapturePort['pageView']>[0],
  ): ReturnType<AnalyticsCapturePort['pageView']> {
    return await this.#analytics().pageView.mutate(input);
  }

  async measure(
    input: Parameters<AnalyticsCapturePort['measure']>[0],
  ): ReturnType<AnalyticsCapturePort['measure']> {
    return await this.#analytics().measure.mutate(input);
  }

  async availability(
    input: Parameters<AnalyticsCapturePort['availability']>[0],
  ): ReturnType<AnalyticsCapturePort['availability']> {
    return await this.#analytics().availability.query(input);
  }

  #analytics(): NonNullable<WebTrpcClient['member']>['analytics'] {
    const analytics = this.#client.member?.analytics;
    if (analytics === undefined) {
      throw new Error(
        'TrpcAnalyticsCaptureAdapter: member.analytics is absent on the AppRouter — ' +
          'browser capture requires the 047 API activation.',
      );
    }
    return analytics;
  }
}
